import { render, staticRenderFns } from "./ShowForm.vue?vue&type=template&id=2f30ec22"
import script from "./ShowForm.vue?vue&type=script&lang=js"
export * from "./ShowForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f30ec22')) {
      api.createRecord('2f30ec22', component.options)
    } else {
      api.reload('2f30ec22', component.options)
    }
    module.hot.accept("./ShowForm.vue?vue&type=template&id=2f30ec22", function () {
      api.rerender('2f30ec22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Formcreated/components/ShowForm.vue"
export default component.exports